export default "__VITE_ASSET__PUkWkGEd__"